<template>
  <div v-if="any_errors">
    <div v-for="error in decodedErrors">
      <div class="alert alert-danger" role="alert" style="display:flex;">
          <strong v-if="errors[error].label">{{error}} </strong>
          <ul>
            <li v-for="(em, idx) in errors[error]" :keys="'error-message-' + idx ">{{em}}</li>
          </ul>
          <button class="closed" data-dismiss="alert" @click="clear_single_error()">
            <!-- <i class="fa fa-times"></i> -->
          </button>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex"
export default {
  name:"CashNotifications",

  computed:{
    ...mapGetters("cash", ["errors", "any_errors"]),

    decodedErrors(){
      return _.keys(this.errors)
    },
  },

  methods:{
    ...mapActions("cash", ["clear_single_error"]),
  }
}
</script>
<style scoped>
.closed {
  background-position: -95px -10px !important;
  background: url(/static/media/noti-cross.8b70ae64.png) no-repeat scroll 0 0 transparent;
  /*float: right;*/
  width: 10px;
  height: 15px;
  opacity: 0.8;
  /*border: solid 1px black;*/
  border:none;
  margin-left: auto;
  margin-top: auto;
}
</style>



// WEBPACK FOOTER //
// client/components/Cash/Notifications.vue